/** Tron FullNode REST：多节点 + 429 退避，避免单点 TronGrid 限流 */

const TRON_REST_HOSTS = [
  'https://api.trongrid.io',
  'https://api.tronstack.io',
]

let activeHostIdx = 0
let readOnlyTronWebCache = null

function sleep(ms) {
  return new Promise((r) => setTimeout(r, ms))
}

export function getTronFullHost() {
  return TRON_REST_HOSTS[activeHostIdx % TRON_REST_HOSTS.length]
}

export function rotateTronHost() {
  activeHostIdx = (activeHostIdx + 1) % TRON_REST_HOSTS.length
  readOnlyTronWebCache = null
  console.warn('[hieswap] Tron REST failover →', getTronFullHost())
  return getTronFullHost()
}

export function invalidateTronWebCache() {
  readOnlyTronWebCache = null
}

export function getCachedReadOnlyTronWeb() {
  return readOnlyTronWebCache
}

export function setCachedReadOnlyTronWeb(tw) {
  readOnlyTronWebCache = tw
}

function isRateLimitStatus(status) {
  return status === 429 || status === 503 || status === 502
}

function isRateLimitError(err) {
  const status = Number(err?.status ?? err?.statusCode ?? err?.response?.status)
  if (isRateLimitStatus(status)) return true
  return /429|503|rate limit|too many requests/i.test(String(err?.message ?? err ?? ''))
}

/**
 * POST Tron FullNode REST（wallet/*、walletsolidity/*）
 * 429/503 时切换节点并退避重试。
 */
export async function tronRestFetch(path, body, opts = {}) {
  const maxTries = opts.maxTries ?? TRON_REST_HOSTS.length * 3
  let lastErr
  for (let i = 0; i < maxTries; i++) {
    const host = getTronFullHost()
    try {
      const res = await fetch(`${host}/${path}`, {
        method: 'POST',
        headers: { 'content-type': 'application/json', ...(opts.headers || {}) },
        body: JSON.stringify(body),
      })
      if (isRateLimitStatus(res.status)) {
        rotateTronHost()
        await sleep(600 + i * 500)
        lastErr = new Error(`Request failed with status code ${res.status}`)
        lastErr.status = res.status
        continue
      }
      if (!res.ok) {
        const err = new Error(`Request failed with status code ${res.status}`)
        err.status = res.status
        throw err
      }
      return await res.json()
    } catch (e) {
      lastErr = e
      if (isRateLimitError(e)) {
        rotateTronHost()
        await sleep(600 + i * 500)
        continue
      }
      throw e
    }
  }
  throw lastErr || new Error('TRON_REST_FAILED')
}

/** TronWeb axios 429 时切换节点并重试 */
export async function withTronWebRetry(fn, opts = {}) {
  const maxTries = opts.maxTries ?? TRON_REST_HOSTS.length * 2
  let lastErr
  for (let i = 0; i < maxTries; i++) {
    try {
      return await fn()
    } catch (e) {
      lastErr = e
      if (!isRateLimitError(e)) throw e
      rotateTronHost()
      await sleep(600 + i * 500)
    }
  }
  throw lastErr
}
